import { render } from "./CoockieBar.vue?vue&type=template&id=00d608ac"
import script from "./CoockieBar.vue?vue&type=script&lang=js"
export * from "./CoockieBar.vue?vue&type=script&lang=js"

import "./CoockieBar.vue?vue&type=style&index=0&id=00d608ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__